import React from 'react';
import { Link } from 'react-router-dom';
import { posts } from '../data/posts';
import SafeIcon from '../common/SafeIcon';
import { FiClock, FiUser, FiArrowRight } from 'react-icons/fi';

const Home = () => {
  const featuredPost = posts[0];
  const recentPosts = posts.slice(1);

  return (
    <main className="flex-grow">
      {/* Hero Section / Featured Post */}
      <section className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <span className="inline-block px-3 py-1 bg-indigo-100 text-indigo-700 font-semibold text-xs rounded-full uppercase tracking-wider mb-4">
                {featuredPost.category}
              </span>
              <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight mb-6 hover:text-indigo-600 transition-colors">
                <Link to={`/post/${featuredPost.id}`}>{featuredPost.title}</Link>
              </h1>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                {featuredPost.excerpt}
              </p>
              
              <div className="flex items-center gap-6 text-sm text-gray-500 mb-8">
                <div className="flex items-center gap-2">
                  <SafeIcon icon={FiUser} />
                  <span>{featuredPost.author}</span>
                </div>
                <div className="flex items-center gap-2">
                  <SafeIcon icon={FiClock} />
                  <span>{featuredPost.date}</span>
                </div>
              </div>

              <Link 
                to={`/post/${featuredPost.id}`}
                className="inline-flex items-center gap-2 bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-700 transition-colors"
              >
                Baca Selengkapnya
                <SafeIcon icon={FiArrowRight} />
              </Link>
            </div>
            
            <div className="order-1 lg:order-2">
              <Link to={`/post/${featuredPost.id}`} className="block overflow-hidden rounded-2xl shadow-xl">
                <img 
                  src={featuredPost.image} 
                  alt={featuredPost.title} 
                  className="w-full h-[400px] object-cover hover:scale-105 transition-transform duration-500"
                />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Recent Posts Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-3xl font-bold text-gray-900 relative inline-block">
            Artikel Terbaru
            <span className="absolute bottom-0 left-0 w-1/2 h-1 bg-indigo-600 -mb-2 rounded"></span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {recentPosts.map((post) => (
            <article key={post.id} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow border border-gray-100 flex flex-col">
              <Link to={`/post/${post.id}`} className="block overflow-hidden h-56 relative group">
                <img 
                  src={post.image} 
                  alt={post.title} 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-indigo-700 font-semibold text-xs rounded-full shadow-sm">
                    {post.category}
                  </span>
                </div>
              </Link>
              
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-center gap-4 text-xs text-gray-500 mb-3">
                  <span>{post.date}</span>
                  <span className="w-1 h-1 rounded-full bg-gray-300"></span>
                  <span>{post.readTime}</span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 hover:text-indigo-600 transition-colors">
                  <Link to={`/post/${post.id}`}>{post.title}</Link>
                </h3>
                
                <p className="text-gray-600 mb-6 line-clamp-3 flex-grow">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold text-sm">
                      {post.author.charAt(0)}
                    </div>
                    <span className="text-sm font-medium text-gray-900">{post.author}</span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Home;